import { NavLink } from 'react-router-dom';

import { BackArrowIcon } from 'src/components/icons';
import { ROOT_PATH } from 'src/constants/routes.constants';

import './avatar-builder-header.scss';

export const AvatarBuilderHeader = () => (
  <header className="avatar-builder-header">
    <NavLink
      to={ROOT_PATH}
      className="avatar-builder-header__back-button"
      aria-label="Back"
    >
      <BackArrowIcon className="avatar-builder-header__back-icon" />
    </NavLink>
    <h2 className="avatar-builder-header__title">Make Your Avatar</h2>
  </header>
);
